import React, { useState } from 'react';
import './Wiki.css';
import StickyLogo from './StickyLogo';

const Wiki = () => {
  const [activeTab, setActiveTab] = useState('User');

  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="wiki-container">
      <StickyLogo />
      <div className="sidebar">
        <div className="tab" onClick={() => toggleTab('User')}>
          User
        </div>
        <div className="tab" onClick={() => toggleTab('Store')}>
          Store
        </div>
      </div>
      <div className="sidebar-divider"></div>
      <div className="content">
        <div className="wiki-header">
          <h1>{activeTab} Section</h1>
        </div>
        <div className="wiki-content">
          {/* Replace with your dummy text */}
          {activeTab === 'User' && <p>This is the User section content.</p>}
          {activeTab === 'Store' && <p>This is the Store section content.</p>}
        </div>
      </div>
    </div>
  );
};

export default Wiki;
